export default __webpack_public_path__ + "static/media/002.3103abd6.jpg";